"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURRENCIES = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["NOK"] = "NOK";
    Currency["EUR"] = "EUR";
    Currency["GBP"] = "GBP";
    Currency["SEK"] = "SEK";
    Currency["USD"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
exports.CURRENCIES = [
    {
        code: Currency.NOK,
        name: 'Norwegian Krone',
        symbol: 'kr',
    },
    {
        code: Currency.EUR,
        name: 'Euro',
        symbol: '€',
    },
    {
        code: Currency.GBP,
        name: 'Pound sterling',
        symbol: '£',
    },
    {
        code: Currency.SEK,
        name: 'Swedish Krona',
        symbol: 'kr',
    },
    {
        code: Currency.USD,
        name: 'US Dollar',
        symbol: '$',
    },
];
